import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "./cn";
export function Label({ className, ...props }) {
    return (_jsx("label", { className: cn("flex items-center gap-2 text-sm font-medium leading-none text-foreground peer-disabled:cursor-not-allowed peer-disabled:opacity-50", className), ...props }));
}
//# sourceMappingURL=label.js.map